module.exports = __webpack_public_path__ + "img/logo_zertu.f6252dbc.png";